<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Detalle Cliente</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="'/'">Dashboard</a></li>
                    <li class="breadcrumb-item active">Detalle Cliente</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="row  justify-content-center">
        <div class="col-xl-10 col-12">
            <div class="card">
                <div class="card-header">
                    <a class="btn btn-outline-success btn-lg" onclick="history.go(-1);">
                        <i class="fas fa-arrow-alt-circle-left"></i> Volver
                    </a>
                </div>
            </div>
            <div class="row  justify-content-center">
                <div class="col-lg-3">
                    <div class="card card-dark">
                        <div class="card-header">
                            <div class="card-title">Datos Cliente</div>
                        </div>
                        <div class="card-body" *ngIf="cliente">
                            <input type="hidden" id="idCliente" name="idCliente" />
                            <input type="hidden" id="idDireccion" name="idDireccion" />
                            <div class="row">
                                <div class="col-12 border-bottom" *ngIf="cliente.nombre">
                                    <span class="item-info d-flex flex-row justify-content-start"><i
                                            class="fas fa-user pr-2 py-1 fs-18 w-28px text-center"></i>
                                        <div>{{cliente.nombre_completo}}</div>
                                    </span>
                                </div>
                                <div class="col-12 border-bottom" *ngIf="cliente.email">
                                    <span class="item-info d-flex flex-row justify-content-start"><i
                                            class="fas fa-at pr-2 py-1 fs-18 w-28px text-center"></i>
                                        <div>{{cliente.email}}</div>
                                    </span>
                                </div>
                                <div class="col-12 border-bottom" *ngIf="cliente.telefono">
                                    <span class="item-info d-flex flex-row justify-content-start"><i
                                            class="fas fa-phone pr-2 py-1 fs-18 w-28px text-center"></i>
                                        <div>{{cliente.telefono}}</div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-dark">
                        <div class="card-header">
                            <div class="card-title">Direcciones del cliente</div>
                        </div>
                        <div class="card-body py-2" *ngIf="cliente">
                            <div class="row">
                                <div class="col-12 border-bottom"
                                    *ngFor="let item of cliente.direccions; let i = index">
                                    <div class="row">
                                        <div class="col-12 py-2">
                                            <div class="item-info d-flex flex-row justify-content-start"><i
                                                    class="fas fa-map-marker-alt pr-2 py-1 fs-18 w-28px text-center"></i>
                                                <a (click)="openDetail(i, item)" class="cursor-pointer">{{item.direccion}},
                                                    {{item.detalle != "" && item.detalle != null ? 
                                                    item.detalle + ", " : ""}}
                                                    {{item.comuna_nombre}},
                                                    {{item.provincia_nombre}},
                                                    {{item.region_nombre}}</a>
                                            </div>
                                        </div>
                                        <div class='col-12 border-bottom p-1 holds-the-iframe' *ngIf="isExpanded[i]">
                                            <div class="mapouter">
                                                <div class="gmap_canvas">
                                                    <iframe width="100%" height="200" id="gmap_canvas"
                                                        [src]="mapa"
                                                        frameborder="0" scrolling="no" marginheight="0"
                                                        marginwidth="0"></iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9">
                    <app-lista-pedidos label="Pedidos" (updateData)="getData(cliente.id_cliente)" [rows]="pedidos"
                        [tempRows]="pedidos" [isLoading]="isLoading" [showCliente]="false"></app-lista-pedidos>
                </div>
            </div>
        </div>
    </div>
</section>